import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class UfService {

    getUFs(): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/uf/visualizatodas', { observe: 'response' })
    }

    getUfsPorPais(paisId: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/uf/visualizaporpais/' + paisId, { observe: 'response' })
    }


    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
